import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { LoadingService } from './loading.service';

@Component({
  selector: 'app-global-loader',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (isLoading()) {
      <div
        class="fixed top-0 left-0 w-full h-1 z-9999 overflow-hidden bg-primary/20 pointer-events-none"
        role="progressbar"
        aria-valuetext="Loading..."
      >
        <div class="h-full bg-primary progress-bar"></div>
      </div>
    }
  `,
  styles: [
    `
      .progress-bar {
        width: 50%;
        transform-origin: left;
        animation: progress 1.5s infinite ease-in-out;
      }

      @keyframes progress {
        0% {
          transform: translateX(-150%) scaleX(0.2);
        }
        50% {
          transform: translateX(-10%) scaleX(1.5);
        }
        100% {
          transform: translateX(250%) scaleX(0.2);
        }
      }
    `,
  ],
})
export class GlobalLoaderComponent {
  private readonly loadingService = inject(LoadingService);
  public readonly isLoading = this.loadingService.isLoading;
}
